import BeeswaxPacing from '@/Enums/Beeswax/BeeswaxPacing.enum';

export const BeeswaxPacingLabel: Record<BeeswaxPacing, string> = {
  [BeeswaxPacing.ASAP]: 'ASAP',
  [BeeswaxPacing.Lifetime]: 'Lifetime',
};
